/***
 * @file:
 * @Date: 2020-06-30 09:34:20
 * @author: manyao.zhu
 */
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { DictionaryService } from '@ithinkdt/shared/dict';
import { ControlValueAccessorService } from '../../control-value-accessor.service';
import monitor from '../../monitor';

const noop = () => {};

@Component({
  selector: 'dt-form-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormCheckboxComponent),
      multi: true,
    },
  ],
})
export class FormCheckboxComponent extends ControlValueAccessorService {
  value;
  @Input() set list(data) {
    if (this.checkList !== data && this.checkList.length && data.length) {
      this.writeValue([]);
      this.updateChanges();
      this.valueChange.emit([]);
    }
    this.checkList = data;
  }
  checkList = [];
  @Input() size = 'default';
  @Input() prop = '';
  @Input() type = '';
  @Input() otherProp = '';
  @Input() bindKey = '';
  @Input()
  set dictCode(code: string) {
    this.setList(code);
  }
  @Input() set checkboxOther(value) {
    monitor.emit('checkboxValues', this.otherProp, value);
    this.otherValue = value;
  }
  otherValue = '';
  @Output() valueChange = new EventEmitter<any>();
  dictConf: any;
  constructor(private settingsSrv: SettingsService, private dictSrv: DictionaryService) {
    super();
    this.dictConf = this.settingsSrv.userConfig['pages'].dictConf || {};
  }

  // æ§ä»¶å¼è®¿é®å¨çåè°å ä½ç¬¦
  onTouchedCallback: () => void = noop;
  onChangeCallback: (_: any) => void = noop;
  // æ¯å¦è¢«ç¦ç¨
  isDisabled: boolean;
  // å¤±å»ç¦ç¹
  onBlur() {
    this.onTouchedCallback();
  }

  setList(code: string) {
    if (!code) {
      return;
    }
    this.dictSrv.getDicListByDicCode(code).subscribe((res: any) => {
      if (res.status && res.data) {
        const list = [];
        const parseLable = this.dictConf.label;
        const parseValue = this.dictConf.value;
        res.data.forEach((i) => {
          list.push({
            value: i[parseValue],
            label: i[parseLable],
            disabled: false,
            checked: false,
          });
        });
        this.checkList = list;
      }
    });
  }

  // updateChanges() {
  //   this.onChangeCallback(this.value);
  // }

  // ControlValueAccessorçæ¥å£ï¼ ç¶ç»ä»¶å¼æ´æ°
  writeValue(value: any) {
    this.value = value;
    if (!value || !value.length) {
      (this.checkList || []).forEach((item) => {
        item.checked = false;
      });
    } else {
      (this.checkList || []).forEach((item) => {
        if (!value.some((t) => t === item.value)) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
    }
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    }
  }

  // // ControlValueAccessorçæ¥å£ï¼ æ¨éå­ç»ä»¶æ´æ°çå¼
  // registerOnChange(fn: any) {
  //   this.onChangeCallback = fn;
  // }

  // // ControlValueAccessorçæ¥å£,è¡¨åæ§ä»¶æ¯å¦è¢«è®¿é®è¿
  // registerOnTouched(fn: any) {
  //   this.onTouchedCallback = fn;
  // }

  // // è·å¾æ§ä»¶æ¯å¦ç¦ç¨çç¶æ
  // setDisabledState(isDisabled: boolean) {
  //   this.isDisabled = isDisabled;
  // }
  checkboxValueChange(checkbox: string[]) {
    if (!checkbox.includes('_other_') && (this.value || []).includes('_other_')) {
      this.otherValue = '';
      monitor.emit('checkboxValues', this.otherProp, this.bindKey, this.otherValue);
    }
    this.writeValue(checkbox);
    this.onChangeCallback(checkbox);
    this.valueChange.emit(checkbox);
  }
  checkboxChanges(evt) {
    const checkbox = evt.reduce((arr, item, i) => {
      if (item.checked) {
        arr.push(item.value);
      }
      return arr;
    }, []);
    this.onChangeCallback(checkbox);
    this.valueChange.emit(checkbox);
  }
  inputBlur() {}
  onKeyup() {}
  inputChange(evt) {
    const value = evt.target.value;
    monitor.emit('checkboxValues', this.otherProp, this.bindKey, value);
  }
}
